import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStoreHours } from "../../api/content";
import styles from "./Footer.module.css";

const locations = [
  {
    name: "Albany, NY",
    address: "1 Crossgates Mall Rd, Unit N202",
    detail: "Level 2, Near Macy's",
    phone: "+1 (201) 539-5928",
    mapLink: "https://maps.google.com/?q=1+Crossgates+Mall+Rd+Albany+NY+12203",
  },
];

const quickLinks = [
  { label: "Buy Tickets", href: "/buy-ticket" },
  { label: "Book a Party", href: "/book-party" },
  { label: "Memberships", href: "/membership" },
  { label: "Events", href: "/events" },
];

const supportLinks = [
  { label: "FAQ", href: "/faq" },
  { label: "Contact Us", href: "/contact" },
  { label: "Waiver Form", href: "/waiver" },
  { label: "Refund Policy", href: "/refund-policy" },
  { label: "My Account", href: "/account" },
  { label: "Careers", href: "/careers" },
];

const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/playfunia_/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61584908417355",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@playfunia",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@playfunia",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

export function Footer() {
  const year = new Date().getFullYear();
  const [businessHours, setBusinessHours] = useState<{ day: string; hours: string }[] | null>(null);
  const [hoursError, setHoursError] = useState(false);

  useEffect(() => {
    getStoreHours('Albany')
      .then((hours) => {
        if (hours && hours.length > 0) {
          setBusinessHours(hours.map((h) => ({ day: h.day, hours: h.hours })));
        } else {
          setHoursError(true);
        }
      })
      .catch(() => {
        setHoursError(true);
      });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className={styles.footer}>
      {/* Main Footer Content */}
      <div className={styles.mainFooter}>
        <div className={styles.container}>
          <div className={styles.footerGrid}>
            {/* Brand Column */}
            <div className={styles.brandColumn}>
              <Link to="/" className={styles.logo}>
                <img src="/images/logo-text.png" alt="Playfunia" />
              </Link>
              <p className={styles.tagline}>
                Where every day is an adventure! Indoor playgrounds designed for active kids and relaxed parents.
              </p>
              <div className={styles.socialLinks}>
                {socials.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.socialIcon}
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.linksColumn}>
              <h4>Visit Us</h4>
              <ul>
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support Links */}
            <div className={styles.linksColumn}>
              <h4>Support</h4>
              <ul>
                {supportLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Location & Contact */}
            <div className={styles.contactColumn}>
              <h4>Our Location</h4>
              {locations.map((location) => (
                <div key={location.name} className={styles.locationCard}>
                  <div className={styles.locationHeader}>
                    <svg viewBox="0 0 24 24" fill="currentColor" className={styles.locationIcon}>
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                    <span className={styles.locationName}>{location.name}</span>
                  </div>
                  <p className={styles.address}>
                    {location.address}
                    <br />
                    {location.detail}
                  </p>
                  <a href={`tel:+1${location.phone.replace(/[^0-9]/g, "")}`} className={styles.phoneButton}>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </svg>
                    {location.phone}
                  </a>
                  <a
                    href={location.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.directionsLink}
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z" />
                    </svg>
                    Get Directions
                  </a>
                </div>
              ))}
            </div>

            {/* Business Hours */}
            <div className={styles.hoursColumn}>
              <h4>Hours</h4>
              {hoursError ? (
                <p className={styles.hoursError}>Hours unavailable — please call for details.</p>
              ) : businessHours ? (
                <ul className={styles.hoursList}>
                  {businessHours.map((item) => (
                    <li key={item.day} className={styles.hoursItem}>
                      <span className={styles.dayName}>{item.day}</span>
                      <span className={styles.hoursTime}>{item.hours}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className={styles.hoursLoading}>Loading hours...</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className={styles.bottomBar}>
        <div className={styles.container}>
          <div className={styles.bottomContent}>
            <p className={styles.copyright}>
              &copy; {year} Playfunia. All rights reserved. | <Link to="/privacy" className={styles.privacyLink}>Privacy Policy</Link>
            </p>
            <button onClick={scrollToTop} className={styles.backToTop} aria-label="Back to top">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
